import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const ProduktTypServiceConfig = {
  name: "ProduktTyp",
  annotations: []
} as ServiceConfig;